export const CONSTANTS = {
  features: [
    {
      text: "Seamless cloud connectivity with intelligent traffic routing",
    },
    {
      text: "Enhanced security with zero-trust network architecture",
    },
    {
      text: "Optimized performance for mission-critical applications",
    },
    {
      text: "Scalable networking to support remote work and IoT expansion",
    },
  ],
  title: "Why choose OneMind for SDN | SD-WAN?",
  description: [
    "OneMind Services delivers next-generation networking solutions that enable businesses to modernize, automate, and secure their IT infrastructure. With cloud-first SDN, SD-WAN, wired, and wireless solutions, we ensure:",
  ],
  extraContent:
    "With OneMind Services, enterprises can future proof their networks and gain a competitive edge in the digital era.",
};
